export default {
  allMsg: 'Wszystkie wiadomości',
  systemMsg: 'Wiadomości systemowe',
  personMsg: 'Wiadomości ręczne',
  unread: 'Nieprzeczytane',
  seeDetail: 'Zobacz szczegóły',
  read: 'Przeczytane',
  replyNow: 'odpowiedz teraz',
  message: 'Wiadomość',
  operateSuccess: 'Operacja zakończona pomyślnie',
  holder: {
    searchHolder: 'Nr paczki/Nr zamówienia/Nr przedmiotu',
  },
  addAcBuy: 'Dołącz do Discorda AcBuy i wygraj ¥2000 w gotówce! ',
  flatActivity: '🎄 Świąteczne Oferty, Których Nie Można Przegapić',
  joinNow1: 'Kup Teraz',
  tips1: '🎁 Rabaty Do 80 %',
  tips2: '🎅 Limitowane Oferty Świąteczne!',
}
